module.exports = __webpack_public_path__ + "media/assets/images/blog/plc-71e590f0a12d8421b7ed92739144184a.jpeg";